import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MDBModalRef, MDBModalService, ModalDirective } from 'angular-bootstrap-md';
import { getScript } from 'jquery';
import * as moment from 'moment';
import { SuccessDialogComponent } from 'src/app/shared/success-dialog/success-dialog.component';
import { WaitingDialogComponent } from 'src/app/shared/waiting-dialog/waiting-dialog.component';
import { ReportsService } from '../reports.service';

@Component({
  selector: 'app-processed-report',
  templateUrl: './processed-report.component.html',
  styleUrls: ['./processed-report.component.scss']
})
export class ProcessedReportComponent implements OnInit {

  rsArray: any;
  xlname: any;
  reportsData: any;
  selectedRs: any = "";
  January: boolean = false;
  February : boolean = false;
  March: boolean = false;
  April: boolean = false;
  May: boolean = false;
  June: boolean = false;
  July: boolean = false;
  August: boolean = false;
  September: boolean = false;
  October: boolean = false;
  November: boolean = false;
  December: boolean = false;
  Total:boolean = false;
  RssoLogin : boolean = false;
  SoLogin: boolean = false;
  AbmLogin: boolean = false;
  RbmLogin: boolean = false;
  NsmLogin: boolean = false;
  DealerLogin: boolean = false;
  xldata: any;
  @ViewChild('downloads', { static: true }) divClick: ElementRef;
  @ViewChild('exportModal', { static: true }) public downloadModalOnClick: ModalDirective;

  constructor(public reportsService: ReportsService, private sanitizer: DomSanitizer, private modalService: MDBModalService, ) {
    this.fromDateValue.setDate(this.fromDateValue.getDate() - 30);
   this.fromDateValue =  moment(this.fromDateValue).format('YYYY-MM-DD');
    let data = JSON.parse(sessionStorage.getItem('userDetails'));
    if(data.DesigId == 4) {
      this.RssoLogin = true;
      this.desigId = "";
    } else if(data.DesigId == 6) {
      this.SoLogin = true;
      // this.getReports();
    } else if(data.DesigId == 7) {
      this.AbmLogin = true;
      // this.getReports();
    } else if(data.DesigId == 8 ) {
      this.RbmLogin = true;
      // this.getReports();
    } else if(data.DesigId == 9) {
      this.NsmLogin = true;
      // this.getReports();
    } else if(data.DesigId == 2 || data.DesigId == 3) {
      this.DealerLogin = true;
      this.desigId  = "";
      // this.getReports();
    }
   }

  ngOnInit() {
    this.getRegion()
  }
  dataFlag: boolean = false;
  selectedRegion: any ;
  toDateValue = moment(new Date()).format('YYYY-MM-DD');
  fromDateValue: any = new Date(); 
  MaxToDate :any  = moment(new Date()).format('YYYY-MM-DD');
  today = moment(new Date()).format('YYYY-MM-DD'); 
  desigId = "IDD";

 getRS() {
  this.reportsService.getRs(this.selectedRegion).then((data: any) => {
    this.rsArray = data;
   }, errorCode => console.log(errorCode));
 }

 onRsChange() {
  this.reportsData = [];
  this.dataFlag = false;
  //  this.getReports();
 }
 regionList:any[]=[];
 getRegion() {
  this.reportsService.getRegion().then((data: any) => {
     this.regionList = data;
     this.selectedRegion = data[0].Region;
    this.getRS();
     }, errorCode => console.log(errorCode));
}

//  @HostListener('document:keydown', ['$event'])
//  handleKeyboardEvent(event: KeyboardEvent) {
//    event.returnValue = false;
//    event.preventDefault();
//  }

  onDateChange(event) {
    console.log("from", this.fromDateValue);
    console.log("to", this.toDateValue);
    let date = new Date(this.fromDateValue);
    date.setDate(date.getDate() + 30);
    this.MaxToDate =  moment(date).format('YYYY-MM-DD');
    this.toDateValue = moment(date).format('YYYY-MM-DD');
    // this.getReports();
  }

  onRegionChange() {
    console.log("Region", this.selectedRegion);
    if(this.desigId == 'IDD') {
      this.getRS();
      this.reportsData = [];
      this.dataFlag = false;
      // this.getReports();
    } else {
      this.selectedRs = "";
      // this.getReports();
    }
  }

  onDesigId() {
    console.log("desigId", this.desigId);
    this.reportsData = [];
    this.dataFlag = false;
    if(this.desigId == 'IDD') {
      this.getRS();
      this.reportsData = [];
      this.dataFlag = false;
      // this.getReports();
    } else {
      this.selectedRs = "";
      // this.getReports();
    }
  }

  successModalRef: MDBModalRef;
  waitingModalRef: MDBModalRef;
 
  export(){
    let valid = false;
    if(this.DealerLogin || this.RssoLogin) {
      this.selectedRegion = '';
     if(this.fromDateValue && this.toDateValue) {
       valid = true;
     } else {
       valid = false;
     }
    }
    if(this.SoLogin || this.AbmLogin) {
      this.selectedRegion = '';
      if(this.fromDateValue && this.toDateValue && this.desigId) {
        valid = true;
      } else {
        valid = false;
      }
     }
     if(this.RbmLogin) {
      this.selectedRegion = '';
      if(this.fromDateValue && this.toDateValue && this.desigId) {
       valid = true;
      } else {
        valid = false;
      }
     }
      if(this.NsmLogin) {
      if(this.fromDateValue && this.toDateValue && this.desigId && this.selectedRegion) {
          valid = true
      } else {
        valid = false;
      }
     }
    
    if(valid) {
      this.waitingModalRef = this.modalService.show(WaitingDialogComponent, {
        data: {
          message: 'please wait'
        }
      });
    this.reportsService.export_Table_excels(this.desigId ,this.fromDateValue, this.toDateValue ,this.selectedRegion, this.selectedRs).then((data) => {
         console.log(data,'data')
       
         if (data.File) {
          setTimeout(x => {
            this.waitingModalRef.hide()
          }, 100)
        this.xlname = data.FileName;
        let url = 'data:application/octet-stream;base64,'+  data.File;
        this.xldata =  this.sanitizer.bypassSecurityTrustResourceUrl(url);
        setTimeout(() => {
          this.divClick.nativeElement.click();
          }, 200);
          this.downloadModalOnClick.hide();
        }
        else {
          setTimeout(x => {
            this.waitingModalRef.hide()
          }, 100)
          let message = "There is no file available for Export";
          this.successModalRef = this.modalService.show(SuccessDialogComponent, {
            data: {
              message: message,
              data: []
            }
          });
          this.successModalRef.content.action.subscribe(result => {
            if (result == 'OK') {
              this.successModalRef.hide();
            }
          })
         
        }
 })
}
}

  getReports() {
    let valid = false;
    if(this.DealerLogin || this.RssoLogin) {
      this.selectedRegion = '';
     if(this.fromDateValue && this.toDateValue) {
       valid = true
     } else {
       valid = false;
     }
    }
    if(this.SoLogin || this.AbmLogin) {
      this.selectedRegion = '';
      if(this.fromDateValue && this.toDateValue && this.desigId) {
        valid = true
      } else {
        valid = false;
      }
     }
     if(this.RbmLogin) {
      this.selectedRegion = '';
      if(this.fromDateValue && this.toDateValue && this.desigId) {
          valid = true;
      } else {
        valid = false;
      }
     }
      if(this.NsmLogin) {
      if(this.fromDateValue && this.toDateValue && this.desigId && this.selectedRegion) {
          valid = true;
      } else {
        valid = false;
      }
     }
    if(valid) {
      this.waitingModalRef = this.modalService.show(WaitingDialogComponent, {
        data: {
          message: 'please wait'
        }
      });
     this.reportsService.getProcessReports(this.desigId ,this.fromDateValue, this.toDateValue ,this.selectedRegion, this.selectedRs).then((data: any) => {
        console.log(data);
        if(data.length> 0) {
          this.reportsData = data;
          this.dataFlag = true;
        } else {
          this.dataFlag = false;
        }
        setTimeout(x => {
          this.waitingModalRef.hide()
        }, 100)
        }, errorCode => console.log(errorCode)
        );
      }
      }
}
